import { combineKeys, queryKey } from '../../../../utils/queryUtils';
import { recordingsKey } from '../../recordings/keys';

export const providersKey = combineKeys(() => [queryKey('providers')(), recordingsKey()]);
